// app/javascript/packs/application.js

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import $ from "jquery"
import "jquery-ui/ui/widgets/datepicker"
import "jquery-ui/ui/widgets/dialog"
import "jquery-ui/ui/widgets/autocomplete"
import "jquery-ui/themes/base/all.css"

import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import "@fortawesome/fontawesome-free/css/all.css"
import "../stylesheets/application.scss"
